import { PlaygroundEnum } from '@utmb/types/enum/PlaygroundEnum';
import { PreferenceDistanceEnum } from '@utmb/types/enum/PreferenceDistanceEnum';
import { PreferenceElevationEnum } from '@utmb/types/enum/PreferenceElevationEnum';
import { PreferencePeriodEnum } from '@utmb/types/enum/PreferencePeriodEnum';
import { PreferencePlaceEnum } from '@utmb/types/enum/PreferencePlaceEnum';

export const places = [
    PreferencePlaceEnum.AFRICA,
    PreferencePlaceEnum.ASIA,
    PreferencePlaceEnum.EUROPE,
    PreferencePlaceEnum.MIDDLE_EAST,
    PreferencePlaceEnum.NORTH_AMERICA,
    PreferencePlaceEnum.SOUTH_AMERICA,
    PreferencePlaceEnum.OCEANIA,
    PreferencePlaceEnum.WORLD,
];

export const distances = [
    PreferenceDistanceEnum.SHORT,
    PreferenceDistanceEnum.MEDIUM,
    PreferenceDistanceEnum.LONG,
    PreferenceDistanceEnum.VERY_LONG,
    PreferenceDistanceEnum.ULTRA,
];

export const periods = [PreferencePeriodEnum.SPRING, PreferencePeriodEnum.SUMMER, PreferencePeriodEnum.FALLS, PreferencePeriodEnum.WINTER];

export const playgrounds = [
    PlaygroundEnum.BEACH,
    PlaygroundEnum.COASTAL_PATH,
    PlaygroundEnum.DAY_TIME,
    PlaygroundEnum.DESERT,
    PlaygroundEnum.GLACIER,
    PlaygroundEnum.HIGH_ALTITUDE,
    PlaygroundEnum.HIKING_TRAIL,
    PlaygroundEnum.HILL,
    PlaygroundEnum.JUNGLE,
    PlaygroundEnum.MOUNTAIN,
    PlaygroundEnum.NIGHT_TIME,
    PlaygroundEnum.ROAD,
    PlaygroundEnum.SINGLE_TRACK,
    PlaygroundEnum.WOODS,
];

export const elevations = [
    PreferenceElevationEnum.VERY_LOW,
    PreferenceElevationEnum.LOW,
    PreferenceElevationEnum.MEDIUM,
    PreferenceElevationEnum.HIGH,
    PreferenceElevationEnum.VERY_HIGH,
    PreferenceElevationEnum.ULTRA,
];
